export let EXPANDED_THEME_VALUES = /*#__PURE__*/function (EXPANDED_THEME_VALUES) {
  EXPANDED_THEME_VALUES[EXPANDED_THEME_VALUES["DARK"] = 1] = "DARK";
  EXPANDED_THEME_VALUES[EXPANDED_THEME_VALUES["LIGHT"] = 2] = "LIGHT";
  return EXPANDED_THEME_VALUES;
}({});
//# sourceMappingURL=expanded-theme.js.map